import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';
import { UpdateBrandLogoRequest } from '../models/brands';

@Injectable({
  providedIn: 'root'
})
export class BrandDataService {

  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public updateBrandLogoAsync(request: UpdateBrandLogoRequest): Promise<any> {
    return this.httpClient.postJsonAsync('BrandWidget/UpdateBrandLogo', request);
  }

  public checkActiveClinicExistsForBrandAsync(brandId: number, timeout?: Promise<any>): Promise<boolean> {
    const request = { brandId: brandId };

    return this.httpClient.getJsonAsync<boolean>('Brands/CheckActiveClinicExistsForBrand', request, timeout);
  }

}
